import { render, staticRenderFns } from "./CharpterTwo.vue?vue&type=template&id=6bdefece&scoped=true&"
import script from "./CharpterTwo.vue?vue&type=script&lang=js&"
export * from "./CharpterTwo.vue?vue&type=script&lang=js&"
import style0 from "./CharpterTwo.vue?vue&type=style&index=0&id=6bdefece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdefece",
  null
  
)

export default component.exports